import { Button } from 'react-bootstrap';
import { useState } from 'react';
import { DateAndTime } from './DateAndTime';

export const DatesAndTimes = ({
	currDatesAndTimes = [{ date: '', time: '' }],
	register,
	unregister,
	error,
}) => {
	const [dateAndTimes, setDateAndTimes] = useState(currDatesAndTimes);

	function addNewDateAndTime() {
		const newDateAndTime = {
			date: '',
			time: '',
		};

		setDateAndTimes(previousDateAndTimes => [
			...previousDateAndTimes,
			newDateAndTime,
		]);
	}

	function removeLastDateAndTime(id) {
		setDateAndTimes([
			...dateAndTimes.slice(0, id),
			...dateAndTimes.slice(id + 1),
		]);
	}

	function commitChange(dateAndTime, idx) {
		const newDateAndTimes = [...dateAndTimes];
		newDateAndTimes[idx] = dateAndTime;
		setDateAndTimes(newDateAndTimes);
	}

	return (
		<div className="mb-5">
			{dateAndTimes.map((dateTime, idx) => {
				return (
					<div key={idx}>
						<DateAndTime
							enableRemove={idx === 0 ? false : true}
							dateTime={dateTime}
							id={idx}
							commitChange={commitChange}
							error={error}
							register={register}
							unregister={unregister}
							handleRemove={removeLastDateAndTime}
						/>
						{dateAndTimes.length > 1 && <hr />}
					</div>
				);
			})}

			<Button
				className="float-right col-sm-12 col-md-4 mt-4 mb-4"
				variant="outline-secondary"
				size="lb"
				onClick={addNewDateAndTime}
				block>
				Add Date & Time
			</Button>
		</div>
	);
};
